// 曝光
import Vue from 'vue'
const visuallyList = [] // 记录已经上报过的埋点信息
const timer = {} // 增加定时器对象
let observer = null // 视窗监听对象
const addListener = (ele, binding) => {
  if (!binding.value.eventName || visuallyList.indexOf(binding.value.id) !== -1) return // 没有埋点事件或者已触发的不执行
  const trackInfo = Object.assign({
    id: '', // 唯一编号
    eventName: '',
    data: null, // 需要上传的埋点数据
    root: null, // 指定视窗（默认为浏览器）
    threshold: 1, // 有效曝光比例
    visuallyTime: 5000 // 有效曝光时间
  }, binding.value)
  const callback = (entries, ob) => {
    entries.forEach(entry => {
      // 没有埋点数据取消上报
      if (!trackInfo.data) {
        ob.unobserve(entry.target)
        return
      }
      if (entry.isIntersecting) {
        timer[trackInfo.id] = setTimeout(function() {
          // 执行上报埋点方法
          Vue.prototype.$sensors.track(trackInfo.eventName, trackInfo.data)
          // 上报成功后取消监听
          ob.unobserve(entry.target)
          visuallyList.push(trackInfo.id)
          timer[trackInfo.id] = null
        }, trackInfo.visuallyTime)
      } else {
        if (timer[trackInfo.id]) {
          clearTimeout(timer[trackInfo.id])
          timer[trackInfo.id] = null
        }
      }
    })
  }
  observer = new IntersectionObserver(callback, {
    root: trackInfo.root,
    threshold: trackInfo.threshold
  })
  observer.observe(ele)
}
const removeListener = (ele) => {
  observer.unobserve(ele)
}

Vue.directive('visually', {
  bind: addListener,
  unbind: removeListener
})
